/*jshint esversion: 6 */
import {initComponents} from './components/_index.js';
import {initBlocks} from './blocks/_index.js';
// import {initPatterns} from './patterns/_index.js';
// import {initPages} from './pages/_index.js';

jQuery(function ($) {
  //console.log('Index Script: Loaded.');
  
  // Initializations
  initBlocks();
  initComponents();
});